import { AlertTriangle, CheckCircle2 } from 'lucide-react'
import { RailCard } from './rail-card'
import type { ResultItem } from './types'

/** 영향 분석 결과에서 영향을 받은 점검 항목 목록을 표시한다. */
export function AffectedItemList({
    resultItems,
    onSelectImpact,
}: {
    resultItems: ResultItem[]
    onSelectImpact(itemId: string): void
}) {
    return (
        <RailCard
            title='영향받은 점검 항목'
            bodyClassName='max-h-44 overflow-y-auto pr-1'>
            {resultItems.length > 0 ? (
                <ul className='grid gap-2'>
                    {resultItems.map((item, index) => (
                        <li key={`${item.item_id}-${index}`}>
                            <button
                                type='button'
                                onClick={() => onSelectImpact(item.item_id)}
                                className='text-foreground hover:border-primary flex w-full items-start gap-2 rounded-sm border border-transparent p-1 text-left text-sm'>
                                {item.recheck_required ? (
                                    <AlertTriangle className='text-warning mt-0.5 size-4 shrink-0' />
                                ) : (
                                    <CheckCircle2 className='text-success mt-0.5 size-4 shrink-0' />
                                )}
                                <span>
                                    <span className='font-medium'>
                                        {item.title ?? item.item_id}
                                    </span>
                                    <span className='text-muted-foreground mt-0.5 block text-xs'>
                                        {item.checklistPath}
                                    </span>
                                </span>
                            </button>
                        </li>
                    ))}
                </ul>
            ) : (
                <p className='text-muted-foreground text-sm'>
                    분석 결과가 생기면 영향 항목과 매뉴얼 조항이 여기에
                    표시됩니다.
                </p>
            )}
        </RailCard>
    )
}
